import { Box } from '@mui/material'
import { isEmpty } from 'lodash'

import { Calf, CalfBadge } from '#/components/FormatCell/Types/Calves/Badge'

type TypeCalvesProps = {
  value?: Calf[]
}

const TypeCalves = ({ value }: TypeCalvesProps) => {
  if (isEmpty(value)) return <span>-</span>

  return (
    <Box sx={{ display: 'inline-flex', gap: 1 }}>
      {value?.map((calf, index) => (
        <CalfBadge {...calf} key={`badge-calf-${index}`} />
      ))}
    </Box>
  )
}

export default TypeCalves
